import { isAppVersionGreaterThanOrEqual, kNativeMapModeVersion } from 'utils/versionUtils';
import { WEB_TEMPORARY_GRAY_ENABLED } from 'utils/grayscaleDriverUtils';
import { DeliveringPath } from 'enums/DeliveryNavigatePathEnum';

export const getDeliveringListPath = async (): Promise<string> => {
    const isGrayEnabled = localStorage.getItem(WEB_TEMPORARY_GRAY_ENABLED) === 'true';
    let isVersionSatisfied = false;
    try {
        isVersionSatisfied = await isAppVersionGreaterThanOrEqual(kNativeMapModeVersion);
    } catch (error) {
        isVersionSatisfied = false;
    }
    return isGrayEnabled && isVersionSatisfied
        ? "/delivery/delivering/temporary"
        : DeliveringPath.DELIVERY_DELIVERING;
};
